import { Box, Grid, Typography } from '@mui/material';
import { LineChart, PieChart } from '@mui/x-charts';
import type React from 'react';
import type { ChartData } from './types';

interface OverviewTabProps {
  chartData: ChartData;
}

export const OverviewTab: React.FC<OverviewTabProps> = ({ chartData }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h6" gutterBottom sx={{ pl: 2 }}>
            Daily Activity Trend
          </Typography>
          {chartData.dailyData && chartData.dailyData.length > 0 ? (
            <Box sx={{ height: 300 }}>
              <LineChart
                dataset={chartData.dailyData}
                xAxis={[{ dataKey: 'date', scaleType: 'point' }]}
                series={[{ dataKey: 'activities', label: 'Activities', color: '#8884d8' }]}
                height={280}
              />
            </Box>
          ) : (
            <Typography color="text.primary" sx={{ mt: 2 }}>
              No activity data available.
            </Typography>
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h6" gutterBottom sx={{ pl: 2 }}>
            Activity Type Distribution
          </Typography>
          {chartData.activityTypeData && chartData.activityTypeData.length > 0 ? (
            <Box sx={{ height: 300 }}>
              <PieChart
                series={[
                  {
                    data: chartData.activityTypeData,
                    highlightScope: { fade: 'global', highlight: 'item' },
                    faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                  },
                ]}
                slotProps={{
                  legend: {
                    position: { vertical: 'middle', horizontal: 'end' },
                  },
                }}
                height={280}
              />
            </Box>
          ) : (
            <Typography color="text.primary" sx={{ mt: 2 }}>
              No activity data available.
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
